export default "__VITE_ASSET__B$il58DN__"